export default "__VITE_ASSET__BVcHne04__"